function load (urls) {
  return Promise.all(urls.map(url => new Promise((resolve, reject) => {
    const tag = buildTag(url)
    tag.onload = resolve
    tag.onerror = reject
    document.head.appendChild(tag)
  })))

  function buildTag (url) {
    const extension = url.match(/.(js|css)$/)[1]

    switch (extension) {
      case 'js':
        return js(url)
      case 'css':
        return css(url)
      default:
        console.warn('Unknown extension')
    }
  }

  function js (url) {
    const tag = document.createElement('script')
    tag.src = url
    tag.async = false
    return tag
  }

  function css (url) {
    const tag = document.createElement('link')
    tag.rel = 'stylesheet'
    tag.href = url
    return tag
  }
}

export default load
